import { Http } from "../utils/http.js";

export class CmsService {
  retrieveEvent(
    calendarId,
    status,
    calendarNameEng,
    calendarNameCn,
    calendarNameHk,
    startDate,
    endDate
  ) {
    var url = "cms/event";
    var postData = {};
    if (status === "create") {
      postData = {
        cmsEventCalendarParameter: {
          calendarNameEng: calendarNameEng,
          calendarNameCn: calendarNameCn,
          calendarNameHk: calendarNameHk,
          startDate: startDate,
          endDate: endDate,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    } else {
      postData = {
        cmsEventCalendarParameter: {
          calendarId: calendarId,
          calendarNameEng: calendarNameEng,
          calendarNameCn: calendarNameCn,
          calendarNameHk: calendarNameHk,
          startDate: startDate,
          endDate: endDate,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    }

    return new Http().post(url, postData);
  }
  retrieveEvents(cPage, recPerPage) {
    var url = "/cms/events";
    var postData = {
      pageableParameter: {
        pageNumber: cPage,
        pageSize: recPerPage,
        orderBy: "updatedDate",
        orderSequence: "desc",
      },
    };

    return new Http().post(url, postData);
  }

  retrieveLink(linkId, status, linkNameEng, linkNameCn, linkNameHk, link) {
    var url = "cms/link";
    var postData = {};
    if (status === "create") {
      postData = {
        cmsQuickLinkParameter: {
          linkNameEng: linkNameEng,
          linkNameCn: linkNameCn,
          linkNameHk: linkNameHk,
          url: link,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    } else {
      postData = {
        cmsQuickLinkParameter: {
          linkId: linkId,
          linkNameEng: linkNameEng,
          linkNameCn: linkNameCn,
          linkNameHk: linkNameHk,
          url: link,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    }

    return new Http().post(url, postData);
  }
  retrieveLinks(cPage, recPerPage) {
    var url = "/cms/links";
    var postData = {
      pageableParameter: {
        pageNumber: cPage,
        pageSize: recPerPage,
        orderBy: "updatedDate",
        orderSequence: "desc",
      },
    };

    return new Http().post(url, postData);
  }

  retrieveCommunication(
    id,
    status,
    communicationNameEng,
    communicationNameHk,
    communicationNameCn,
    isPin,
    startDate,
    endDate
  ) {
    var url = "/cms/communication";
    var postData = {};
    if (status === "create") {
      postData = {
        cmsBrokerCommunicationParameter: {
          isPin: isPin,
          communicationNameEng: communicationNameEng,
          communicationNameHk: communicationNameHk,
          communicationNameCn: communicationNameCn,
          startDate: startDate,
          endDate: endDate,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    } else {
      postData = {
        cmsBrokerCommunicationParameter: {
          communicationId: id,
          isPin: isPin,
          communicationNameEng: communicationNameEng,
          communicationNameHk: communicationNameHk,
          communicationNameCn: communicationNameCn,
          startDate: startDate,
          endDate: endDate,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    }

    return new Http().post(url, postData);
  }

  retrieveCommunications(cPage, recPerPage) {
    var url = "/cms/communications";
    var postData = {
      pageableParameter: {
        pageNumber: cPage,
        pageSize: recPerPage,
        orderBy: "updatedDate",
        orderSequence: "desc",
      },
    };

    return new Http().post(url, postData);
  }

  retrieveLandingCommunications(cPage, recPerPage) {
    var url = "/cms/communications";
    var postData = {
      pageableParameter: {
        pageNumber: cPage,
        pageSize: recPerPage,
        orderBy: "startDate",
        orderSequence: "desc",
      },
    };

    return new Http().post(url, postData);
  }

  retrieveCategoryList() {
    var url = "cms/category/list";
    var postData = {};

    return new Http().post(url, postData);
  }

  retrieveCategory(
    categoryId,
    upperCategoryId,
    status,
    categoryNameEng,
    categoryNameCn,
    categoryNameHk
  ) {
    var url = "cms/category";
    var postData = {};
    if (status === "create") {
      postData = {
        cmsCategoryParameter: {
          upperCategoryId: upperCategoryId,
          categoryNameEng: categoryNameEng,
          categoryNameHk: categoryNameHk,
          categoryNameCn: categoryNameCn,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    } else {
      postData = {
        cmsCategoryParameter: {
          categoryId: categoryId,
          upperCategoryId: upperCategoryId,
          categoryNameEng: categoryNameEng,
          categoryNameHk: categoryNameHk,
          categoryNameCn: categoryNameCn,
        },
        availabilityParameter: {
          availability: status,
        },
      };
    }

    return new Http().post(url, postData);
  }
}
